import SidebarModule from './sidebar/sidebar-module';
import HotelsFactoryModule from './../hotels/services/hotels-factory-module';

import mainEvents from './config/events.constant';

import FooterController from './controllers/footerController';
import HeaderController from './controllers/headerController';
import MainController from './controllers/mainController';
import CopyrightController from './controllers/copyrightController';

import AnimateBasket from './directives/animateBasket.directive';
import Sizebasket from './directives/sizeBasket.directive';

import templateMain from './templates/main.tmpl.html';
import templateHeader from './templates/header.tmpl.html';
import templateFooter from './templates/footer.tmpl.html';
import templateCopyright from './templates/copyright.tmpl.html';
import templateCart from './templates/cart.tmpl.html';

const MODULE_NAME = 'App.Main';
const module = angular
    .module(MODULE_NAME, [
        SidebarModule,
        HotelsFactoryModule,
    ])
    .constant('mainEvents', mainEvents)
    .directive('animateBasket', AnimateBasket)
    .directive('sizebasket', Sizebasket)
    .controller('FooterController', FooterController)
    .controller('HeaderController', HeaderController)
    .controller('MainController', MainController)
    .config(function($stateProvider, $urlRouterProvider) {
        'ngInject';

        // TODO remove when AP-1523 is implemented
        if (!window.jasmine) { //eslint-disable-line
            $urlRouterProvider
                .otherwise('/search/flights/roundtrip');
        }

        $stateProvider
            .state('main', {
                abstract: true,
                url: '/search',
                resolve: {
                    loginFactory: 'loginFactory',
                    availableServices: function(authService, $rootScope) {
                        'ngInject';

                        return $rootScope.readOnlyMode ? null : authService.getAvailableServicesFromSessionStorage();
                    },
                },
                views: {
                    '': {
                        template: templateMain,
                        controller: MainController,
                    },
                    'header@main': {
                        template: templateHeader,
                        controller: HeaderController,
                        controllerAs: 'headerCtrl',
                    },
                    'footer@main': {
                        template: templateFooter,
                        controller: FooterController,
                        controllerAs: 'footerCtrl',
                    },
                    'copyright@main': {
                        template: templateCopyright,
                        controller: CopyrightController,
                        controllerAs: '$ctrl',
                    },
                    'cart@main': {
                        template: templateCart,
                        controller: FooterController,
                        controllerAs: '$ctrl',
                    },
                },
            });
    })
    .run(function($rootScope, scrollService) {
        'ngInject';

        $rootScope.$on('$stateChangeError', function(event) {
            event.preventDefault();
        });

        $rootScope.$on('$stateChangeSuccess', () => {
            scrollService.scrollToTop();
        });
    })
    .run((basketService) => {
        'ngInject';
        basketService.assignWatchers();
        basketService.assignBasketFromRootScopeToLocalStorage();
    });

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/main/main-module.js